import { InsightsOverTimeBinDtoModelSelector } from '../../../models';

export const estimatedDistanceCompletedFragment = (selector: InsightsOverTimeBinDtoModelSelector) => selector.interval.value;
